// Packages
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

// Context
import { useUI } from 'context/UI';

// Components
import BTDProgress from '../BTDProgress';

// Other
import './styles.css';


const BTDButton = ({ className, colour, disabled, formButton, label, onClick, startIcon, style, size, target, type, url }) => {

	const { getLoading } = useUI();

	if(getLoading() && formButton) {

		return(

			<BTDProgress type='circular' />
		)
	}

	return (
		<>
		
		{url ?
				<Link
					to={url} 
					className={`BTDButton BTDButton--colour-${colour} BTDButton--size-${size} BTDButton--type-${type} ${disabled ? 'disabled' : ''} ${startIcon ? 'startIcon' : ''} ${className}`} 
					style={style}
					target={target}
				>
					{startIcon}
					{label}
				</Link>
			:
		
			<button onClick={() => {

				if( ! disabled ) {

					if ( onClick )
					{
						onClick();
					}
				}

			}} style={style} className={`BTDButton BTDButton--colour-${colour} BTDButton--size-${size} BTDButton--type-${type} ${disabled ? 'disabled' : ''} ${startIcon ? 'startIcon' : ''} ${className}`}>
				{startIcon}
				{label}

			</button>
		}
		</>
	);

}

BTDButton.propTypes = {
	className: PropTypes.string,
	colour: PropTypes.string,
	disabled: PropTypes.bool,
	formButton: PropTypes.bool,
	label: PropTypes.string.isRequired,
	onClick: PropTypes.func,
	size: PropTypes.string,
	startIcon: PropTypes.object,
	style: PropTypes.object,
	type: PropTypes.string,
	url: PropTypes.string,
}

BTDButton.defaultProps = {
	className: '',
	colour: 'default',
	disabled: false,
	formButton: false,
	label: '',
	onClick: () => {},
	size: '',
	startIcon: null,
	style: {},
	type: '',
	url: null
}


export default BTDButton;